// eslint-disable-next-line import/no-unassigned-import
import 'promise-any-polyfill';

window.Sq = window.Sq || {};
Sq.Optimizely = Sq.Optimizely || {};

/*
This snippet is conditionally injected onto a page as a fallback snippet to show the hidden elements in the following edge cases:
    1. Script is blocked by browser - incognito / extensions
    2. Script failed to load after 1.5 seconds
    3. An experiment is not running on the page and content is still hidden

*/
Sq.Optimizely.flickerFix = function () {
  let flickerFixApplied = false;

  function showHiddenContent() {
    /*
      'campaignDecided' lifecycle event will trigger for every active campaign,
      we just need to un-hide everything once
    */
    if (flickerFixApplied) {
      return;
    }
    // Shows hidden sections
    // The .sq-custom-flicker-fix class sets a section's visibility to hidden.
    $('.sq-custom-flicker-fix').removeClass('sq-custom-flicker-fix');

    // shows hidden nav
    $('#public-web-nav').removeClass('sq-custom-flicker-fix');

    // For redirect variants, the body will not be visible on initial load. This is set by the page's stylesheet in Contentful.
    const bodyElement = $('body');

    if (bodyElement.css('visibility') === 'hidden') {
      bodyElement.css('visibility', 'visible');
    }
    flickerFixApplied = true;
  }

  function disableOptimizely() {
    // https://docs.developers.optimizely.com/web/docs/disable
    window.optimizely = [
      {
        type: 'disable',
      },
    ];
  }

  function flickerFixFallback() {
    const optimizely = window.optimizely;

    // Optimizely failed to load/initialize, disable Optimizely to prevent flicker in case it loads in the future
    if (!optimizely || !optimizely.initialized) {
      disableOptimizely();
      if (Sq.Tracking.useCDP) {
        Sq.Tracking.cdp.track('Optimizely Disabled');
      }
    }
    showHiddenContent();
  }
  window.optimizely = window.optimizely || [];

  // if optimizely is already initialized, show hidden content right away
  if (window.optimizely && window.optimizely.initialized) {
    showHiddenContent();
  } else {
    // https://github.com/optimizely/library/tree/master/nonblocking-snippet
    window.optimizely.push({
      type: 'addListener',
      filter: {
        type: 'lifecycle',
        name: 'campaignDecided',
      },
      handler: showHiddenContent,
    });
    setTimeout(flickerFixFallback, 1500);
  }
};
Sq.Optimizely.flickerFix();
